<template>
  <div class="pic_bg">
    <header>
      <el-image :src="iconHeader"></el-image>
      <span class="title_font">{{ titleName }}</span>
    </header>
    <body>
      <el-table
        :data="list"
        style="width: 100%">
        <el-table-column
          prop="examName"
          label="试卷名称">
        </el-table-column>
        <el-table-column
          prop="examStarttime"
          label="考试开始时间">
        </el-table-column>
        <el-table-column
          prop="examEndtime"
          label="考试结束时间">
        </el-table-column>
        <el-table-column
          prop="examDuration"
          label="考试用时（分）">
        </el-table-column>
        <el-table-column
          prop="totalScore"
          label="考试分数">
        </el-table-column>
      </el-table>
      <div class="page">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageNum"
          :page-sizes="[10, 20, 50]"
          :page-size="100"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </body>
  </div>
</template>

<script>
import { getExamrecord } from "@/network/api";
export default {
  data() {
    return {
      titleName: '考试结果',
      iconHeader: require("@/assets/images/pageico_4.png"),
      list: [],
      total: 0,
      pageNum: 1,
      pageSize: 10
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.queryExamrecord()
    },
    queryExamrecord() {
      getExamrecord({
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }).then(res => {
        this.list = res.rows;
        this.total = res.total;
      })
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.queryExamrecord()
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.queryExamrecord()
    }
  }
}
</script>

<style scoped>
.pic_bg {
  width: 1150px;
  margin: 0 auto;
}
header {
  width: 1150px;
  display: flex;
  margin-bottom: 6px;
  align-items: center;
}
body {
  width: 1150px;
  margin-top: 12px;
  margin-bottom: 12px;
  min-height: 100px;
}
.title_font {
  color: #397b3e;
  font-size: 20px;
  margin-left: 6px;
}
.btn-h:hover {
  cursor: pointer;
}
.page {
  width: 100%;
  display: flex;
  justify-content: center;
}
</style>


// WEBPACK FOOTER //
// src/components/ExaminationResults.vue